export interface EmployeeBase {
  first_name?: string;
  last_name?: string;
  role?: EmployeeRoleType;
  idnum_type?: IdNumType;
}

export enum IdNumType {
  RSAID = 1,
  Passport = 2,
}

export interface EmployeeRequest extends EmployeeBase {
  email: string;
  phone: string;
  idnum: string;
  topup_frequency?: TopUpFrequency | null;
  topup_amount?: string | null;
  approvers?: string[] | null;
  create_card?: boolean;
  date_of_birth?: string;
}

export interface Employee extends EmployeeBase {
  id: string;
  email: string;
  phone: string;
  idnum: string;
  idnum_status: EmployeeIdentityDocumentStatus | null;
  status?: string;
  created: string;
  is_approver: boolean;
  is_card_holder: boolean;
  is_subscription_card_holder: boolean;
  email_verified?: boolean;
  phone_verified?: boolean;
  contact_change_pending?: boolean;
  approvers?: EmployeeApprover[];
}

export interface EmployeeApprover {
  email: string;
  id: string;
  name: string;
}

export interface EmployeeInviteResponse {
  detail: string;
}

export interface FileUploadData {
  file: string;
  approver: string;
  id?: number;
}

export interface FileUploadResponse {
  created: Date;
  error?: string;
  error_rows: number;
  file: string;
  id: number;
  status: number;
  total_rows: number;
  updated: Date;
}

export interface FileUploadErrors {
  row: number;
  errors: FileError[];
}

export interface FileError {
  msg: string;
  type: string;
  field: string;
  input: string;
}

export interface EmployeeIdentityDocumentRequest {
  id_number: string;
  file_front: string;
  file_back: string;
}

export interface EmployeeIdentityDocument {
  status: EmployeeIdentityDocumentStatus;
  status_reason: string;
}

export interface ReplaceApproverRequest {
  replacement: string;
}

export enum EmployeeRoleState {
  User = 1,
  Admin = 10,
}

export enum EmployeeRoleType {
  USER = 'User',
  ADMIN = 'Admin',
}

export enum EmployeeIdentityDocumentStatus {
  None = -1, // doesnt exist
  New = 0, // user uploaded successfully i.e. action has taken place
  Verified = 10,
  Error = 50, // error on Secure citizen side
  Rejected = 100, // no barcode detected, wrong id, cant process image etc.
}

export enum TopUpFrequency {
  Daily = 1,
  Weekly = 2,
  Monthly = 3,
}

export enum TopUpFrequencyLabel {
  DAILY = 'Daily',
  WEEKLY = 'Weekly',
  MONTHLY = 'Monthly',
}
